<template>
  <div class="col-md-12 ml-auto mr-auto">
    <button
      v-if="!showFilters"
      type="text"
      :class="'btn btn-info btn-fill w-100 max-180 mb-4' + this.filtroAtivo"
      @click.prevent="showFilters = true"
    >Filtros  <i class="fa fa-filter"></i></button>
    <card v-if="showFilters" class="col-xl-10 col-sm-12 ml-auto mr-auto">
      <h4 class="card-title">Filtros</h4>
      <form action="#">
        <div class="row">
          <div class="col-md-3">
            <base-input
              type="text"
              label="Referencia"
              v-model="filtros.referencia"
              placeholder="Referência"
            ></base-input>
          </div>

          <div class="col-md-3">
            <base-input type="text" label="Porto" v-model="filtros.porto" placeholder="Porto"></base-input>
          </div>

          <div class="col-md-3">
            <base-input type="text" label="Contato" v-model="filtros.contato" placeholder="Contato"></base-input>
          </div>

          <div class="col-md-3">
            <base-input type="text" label="Numero do PO" v-model="filtros.po" placeholder="Numero do PO"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <base-input
              type="text"
              label="N House"
              v-model="filtros.nHouse"
              placeholder="N House"
            ></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">Tipo de Busca</label>
              <select name="tipoBusca" id="tipoBusca" v-model="filtros.tipoBusca" class="form-control">
                <option value="embarque">EMBARQUE CRIADO</option>
                <option value="etd">ETD</option>
                <option value="eta">ETA</option>
                <option selected value=""> </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <base-input
              :disabled="filtros.tipoBusca == ''"
              type="date"
              label="DataInicial"
              v-model="filtros.dataInicial"
              placeholder="Data Inicial"
            ></base-input>
          </div>
          <div class="col-md-4">
            <base-input
              :disabled="filtros.dataInicial == ''"
              type="date"
              label="DataFinal"
              v-model="filtros.dataFinal"
              placeholder="Data Final"
            ></base-input>
          </div>
        </div>


        <div class="row">
          <div class="col-6 mt-auto mb-auto p-2 text-center">
            <button
              :disabled="(filtros.tipoBusca != '' && filtros.dataFinal == '')"
              type="submit"
              class="btn btn-info btn-fill w-100"
              @click.prevent="searchProcess"
            >Pesquisar</button>
          </div>
          <div class="col-6 mt-auto mb-auto p-2 text-center">
            <button
              type="submit"
              class="btn btn-clear w-100"
              @click.prevent="clearFiltros"
            >Limpar Filtros</button>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "filterProcess",
      showFilters: false,
      filtroAtivo: "btn-blue",
      filtros: {
        referencia: "",
        po: "",
        porto: "",
        periodo: "",
        contato: "",
        dataInicial: "",
        dataFinal: "",
        tipoBusca: "",
        nHouse: "",
      }
    };
  },
  methods: {
    searchProcess() {
      this.$emit("updateFiltros", this.filtros);
      this.showFilters = false;
      this.checkFiltros();
      // this.clearFiltros();
    },
    clearFiltros() {
      this.filtros = {
        referencia: "",
        po: "",
        porto: "",
        periodo: "",
        contato: "",
        dataInicial: "",
        dataFinal: "",
        tipoBusca: "",
        nHouse: "",
      };
      this.searchProcess();
    },
    clearPeriodo(){
      this.filtros.dataInicial = "";
      this.filtros.dataFinal = "";
    },
    checkFiltros(){
      let empty = "btn-blue";
      for (const filtro of Object.values(this.filtros)) {
        if (filtro){
          empty = "btn-red";
          break;
        }
      }
      
      this.filtroAtivo = empty;
    }
  },
  mounted(){
    this.checkFiltros();
  },
  updated(){
    if(this.filtros.tipoBusca == "" || this.filtros.dataInicial == ""){
      this.clearPeriodo();
    }
  }
};
</script>

<style>
.btn-red{
  background-color: #a33623 !important;
  border-color: #99311e !important;
}
.btn-blue{
  background-color: #1dc7ea;
}
.btn-clear{
  background-color: rgb(167, 165, 165);
  border-color: rgb(167, 165, 165);
  color: white;
  
}

.max-180{
  max-width: 210px;
}
</style>
